import { MessageAlertType } from 'models/commonModel';
import store from 'cache/store';
import { toggleMessage } from 'features/configSlice';

const alertMsg = (message: string, type: MessageAlertType = 'error', isClickOutside: boolean = false) => {
    const payload = {
        message,
        type: type,
        isClickOutside: isClickOutside,
    };
    store.dispatch(toggleMessage(payload));
};
export default alertMsg;
